
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import GoogleMaps from '../../anonymous/GoogleMaps.vue';

import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import SwitchField from '../../../../framework/fields/SwitchField.vue';

import { sharedState } from '../../../../framework/state';
import { getResource, putResource } from '../../../../framework/client/resource';
import { getEnumerationOptions } from '../../../../framework/service/options';

import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';

import { successToast, errorToast } from '../../../service/toast_service';
import { updateCachedResourceRow } from '../../../service/query_cache_service';
import { FinvoiceParserPattern } from '../../../../../common/application/model/FinvoiceParserPattern';
import { FinvoiceParserPatternType } from '../../../../../common/application/model/enums/FinvoiceParserPatternType';

@Component({
    components: { SelectField, TextField, SwitchField, GoogleMaps, ValidationObserver },
})
export default class EditFinvoiceParserPattern extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.FINVOICE_PARSER_PATTERN;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as FinvoiceParserPattern,
        finvoiceParserPatternTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.finvoiceParserPatternTypeOptions = getEnumerationOptions(
            'FinvoiceParserPatternType',
            Object.keys(FinvoiceParserPatternType),
            this,
        );
        this.local.row = (await getResource<FinvoiceParserPattern>(this.resourceType, this.id))!!;
    }

    save() {
        this.saveResource(false);
    }

    saveAndClose() {
        this.saveResource(true);
    }

    private async saveResource(goBack: boolean) {
        try {
            const updatedRow = await putResource<FinvoiceParserPattern>(this.resourceType, this.id, this.local.row);

            successToast(this, 'message.finvoiceParserPatternSaved');
            updateCachedResourceRow<FinvoiceParserPattern>(updatedRow, this.id, this.resourceType);

            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
